import React, { useEffect, useState } from 'react'
import { reduxForm, formValueSelector, reset } from 'redux-form'
import { connect } from 'react-redux'
import { Col, Row, Card } from 'react-bootstrap'
import { FormControlLabel, Checkbox, Switch, Button } from '@material-ui/core'
import { KeyboardTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import ScheduleIcon from '@material-ui/icons/Schedule'
import DatePicker from '../../../LaridaeApp/datepicker/container/DatePicker'
import 'date-fns'
import DateFnsUtils from '@date-io/date-fns'
import moment from 'moment'
import { EMPLY_CUPOS_ADELANTO } from '../../actions/constants'
import { FORM_CUPO } from '../../../../config/forms'
import { ToastContainer, toast } from 'react-toastify'
import { INTERVALO_CORTO } from '../../../../config/settings'
import { getCupos, adelantarCupos, getAdelantosProgramados, deleteAdelantoProgramado } from '../../actions/AdelantoDeCuposActions'
import AdelantosProgramados from '../../components/adelantoDeCupos/AdelantosProgramados'
import { confirmAlert } from 'react-confirm-alert'

function AdelantoDeCupos (props) {
  const [cupos, setCupos] = useState()
  const [allCereal, setAllCereal] = useState(true)
  const [selectedHour, setSelectedhour] = useState(moment().add(1, 'hours'))
  const cerealesDisponibles = []
  const cereales = []

  useEffect(() => {
    async function getData () {
      setCupos(await getCupos())
      props.getAdelantosProgramados()
    }
    getData()
  }, [props])

  if (cupos && cerealesDisponibles.length === 0) {
    cupos.forEach(cupo => {
      if (!cerealesDisponibles.includes(cupo.claveCereal)) {
        cerealesDisponibles.push(cupo.claveCereal)
      }
    })
  }

  const actualizarFechas = (fechaD, fechaH) => {
    const { change: formChange } = props
    formChange('fechaD', moment(fechaD).format('DD/MM/YYYY'))
    formChange('fechaH', moment(fechaH).format('DD/MM/YYYY'))
  }

  const addCereal = (c) => {
    const { change: formChange, cereal } = props

    cereal.map((cereal) => {
      return cereales.push(cereal)
    })

    if (!cereales.includes(c)) {
      cereales.push(c)
    } else {
      cereales.pop(c)
    }

    formChange('cereales', cereales)
  }

  const addAllCereal = () => {
    const { change: formChange } = props
    if (!allCereal) {
      cerealesDisponibles.map((cereal) => {
        if (!cereales.includes(cereal)) {
          cereales.push(cereal)
        }
        return cereales
      })
    } else {
      cereales.map((cereal) => {
        return cereales.pop(cereal)
      })
    }

    setAllCereal(!allCereal)
    formChange('cereales', cereales)
  }

  const submitAdelanto = () => {
    const { change: formChange, dispatch, cereal } = props

    if (allCereal) {
      cerealesDisponibles.map((cereal) => {
        if (!cereales.includes(cereal)) {
          cereales.push(cereal)
        }
        return cereales
      })
    } else {
      cereal.map((cereal) => {
        return cereales.push(cereal)
      })
    }

    formChange('cereales', cereales)

    if (cereales.length > 0) {
      dispatch(adelantarCupos())
    } else {
      toast.error('Debe seleccionar al menos un cereal para adelantar cupos')
    }

    reset(FORM_CUPO)
    setAllCereal(true)
  }

  const changeHora = (h) => {
    const { change: formChange } = props
    formChange('horaAdelanto', moment(h).format('HH:mm'))
    setSelectedhour(h)
  }

  const handleSubmit = () => {
    if (cerealesAdelanto && cerealesAdelanto.length > 0) {
      confirmAlert({
        title: 'Atención',
        message: 'Al confirmar se eliminará el adelanto programado pendiente',
        buttons: [
          {
            label: 'Confirmar',
            onClick: () => {
              submitAdelanto()
            }

          },
          {
            label: 'Cancelar',
            onClick: () => null
          }
        ] })
    } else {
      submitAdelanto()
    }
  }

  const eliminarAdelantoProgramado = () => {
    props.deleteAdelantoProgramado()
  }

  const { cerealesAdelanto, limiteCupoDesde, limiteCupoHasta, fechaH } = props

  return (
    <>
      <ToastContainer autoClose={INTERVALO_CORTO} />

      <h2>Adelanto de cupos</h2>
      <Card className='shadow rounded card-adelantar-cupos'>
        <p style={{ margin: '5px 10px', textAlign: 'left' }}>Programar adelanto</p>
        {cupos && cupos.length > 0
          ? <>
            <Row style={{ margin: '38px auto', alignItems: 'flex-start', justifyContent: 'center' }}>
              <Col md={10} style={{ margin: '0 auto' }}>
                <Row>
                  <Col md={5} style={{ margin: '22px auto', width: '70%' }}>
                    <DatePicker
                      style={{ width: '95%' }}
                      disabledPast
                      selectRange
                      locale='es'
                      fechaHasta={fechaH}
                      onDateChange={actualizarFechas}
                      titulo='Inicio - Límite de cupo'
                      value='fechas'
                    />
                  </Col>

                  <Col md={3} style={{ margin: '5px auto', width: '70%' }}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardTimePicker
                        style={{ width: '100%' }}
                        margin='normal'
                        id='time-picker'
                        label='Hora'
                        value={selectedHour}
                        defaultValue={moment().add(1, 'hours')}
                        onChange={(e) => { changeHora(e) }}
                        KeyboardButtonProps={{
                          'aria-label': 'Cambiar hora'
                        }}
                        mask='__:__ _M'
                        keyboardIcon={<ScheduleIcon style={{ fontSize: '1.4rem', color: '#495057' }} />}
                      />
                    </MuiPickersUtilsProvider>
                  </Col>
                </Row>
                <p style={{ margin: '22px auto', width: '80%' }}>Los cupos se consumiran hasta las 16hs. del dia seleccionado como limite</p>

              </Col>

              <Col md={10} style={{ margin: '22px auto' }}>
                <FormControlLabel
                  control={<Switch
                    color='primary'
                    name='allCereal'
                    onChange={addAllCereal}
                    checked={allCereal}
                  />}
                  label='Todos los cereales'
                />

                {!allCereal && <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <Col md={12} className='cereales-adelanto-cupos'>
                    {cerealesDisponibles.map((cereal) => (
                      <FormControlLabel
                        style={{ margin: '0 auto' }}
                        key={cereal}
                        control={
                          <Checkbox
                            onChange={() => { addCereal(cereal) }}
                            color='primary'
                          />
                        }
                        label={cereal}
                      />
                    ))
                    }
                  </Col>
                </div>
                }
              </Col>
            </Row>

            <Button
              onClick={() => handleSubmit()}
              size='medium'
              variant='contained'
              color='primary'
              style={{ margin: '22px auto' }}
            >
                Confirmar adelanto
            </Button>
          </>
          : <>
            <h6 style={{ margin: '20% 10px' }}>No existen cupos vigentes que puedan ser adelantados</h6>
          </>
        }
      </Card>

      <br />

      {cerealesAdelanto && cerealesAdelanto.length > 0 && <Col md={12} style={{ margin: '38px auto' }}>
        <AdelantosProgramados
          cerealesAdelanto={cerealesAdelanto}
          limiteCupoDesde={limiteCupoDesde}
          limiteCupoHasta={limiteCupoHasta}
          eliminarAdelantoProgramado={eliminarAdelantoProgramado}
        />
      </Col>
      }
    </>
  )
}

const selector = formValueSelector(FORM_CUPO)

const mapActionsToProps = {
  getCupos,
  adelantarCupos,
  getAdelantosProgramados,
  deleteAdelantoProgramado
}

const mapStateToProps = state => {
  return {
    fechaD: selector(state, 'fechaD'),
    fechaH: selector(state, 'fechaH'),
    horaAdelanto: selector(state, 'horaAdelanto'),
    cereal: selector(state, 'cereales'),
    cerealesAdelanto: state.cupos.cerealesAdelanto,
    limiteCupoDesde: state.cupos.limiteCupoDesde,
    limiteCupoHasta: state.cupos.limiteCupoHasta
  }
}

export default reduxForm({
  form: FORM_CUPO,
  initialValues: EMPLY_CUPOS_ADELANTO,
  enableReinitialize: true
})(connect(mapStateToProps, mapActionsToProps)(AdelantoDeCupos))
